import { ReactElement } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { useWorkspaceLocale } from '@treams/treams-hooks';
import { Portal } from '@treams/treams-ui';

import GoalRevision from '../../../../../../src/goals/GoalRevision';
import ModalNavigation from '../../../../../../src/navigation/ModalNavigation';
import HelpdeskContainer from '../../../../../../src/packages/kakapo-ui-application/common/containers/HelpdeskContainer';
import publicRoutes from '../../../../../../src/packages/kakapo-ui-application/routers/publicRoutes';
import PopoverProvider from '../../../../../../src/packages/kakapo-ui-kit/components/popovers/PopoverProvider';
import Login from './Login';

const AppUnauthenticated = (): ReactElement => {
	const location = useLocation();
	const params = new URLSearchParams(location.search);

	useWorkspaceLocale();

	return (
		<HelpdeskContainer>
			<Portal.Provider fontFamily="Source Sans Pro">
				<PopoverProvider>
					<Switch>
						<Route path="/authentication" strict={false} exact={false}>
							<Login />
						</Route>
						{/* Already signed out; keep /logout out of originalTargetUrl. */}
						<Route path="/logout">
							<Redirect to="/authentication" />
						</Route>
						{[...publicRoutes]}
						<Redirect
							to={{
								pathname: '/authentication',
								state: { originalTargetUrl: location.pathname },
							}}
						/>
					</Switch>
					<ModalNavigation url={params.get('modal') ?? ''}>
						<Switch>
							<Route path="/goals/:id/revisions/:revision">
								{({ match }) => (
									<GoalRevision goalID={match!.params.id} revision={match!.params.revision} />
								)}
							</Route>
						</Switch>
					</ModalNavigation>
				</PopoverProvider>
			</Portal.Provider>
		</HelpdeskContainer>
	);
};

export default AppUnauthenticated;
